import axios from "axios";

import { MainUrl } from "../constants";

export const UploadDashboard = async (token, date, file) => {
  const formData = new FormData();
  formData.append("date", date);
  formData.append("file", file);
  const response = await axios.post(`${MainUrl}/dashboard/upload/`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const GetDashboardDepartments = async (token) => {
  const response = await axios.get(`${MainUrl}/dashboard/departments/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const GetDashboardSummary = async (
  token,
  departmentId,
  dateFrom,
  dateTo,
  restaurantId,
) => {
  const response = await axios.get(`${MainUrl}/dashboard/summary/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      department_id: departmentId,
      date_from: dateFrom,
      date_to: dateTo,
      restaurant_id: restaurantId || undefined,
    },
  });
  return response.data;
};
